<template>
  <div class="score-page" v-if="question_list[index]">
    <header-info
      :week_info="week_info"
      :question_list="question_list"
      :index="randomIndex"
      :timesCN="timesCN"
    ></header-info>
    <div class="top-content">
      <div class="left-part">
        <img src="../assets/imgs/question/exp.png" alt />
        <!-- 倒计时 -->
        <div class="countDown">
          <div class="count-clock"></div>
          <div class="text1">倒计时</div>
          <!-- <div class="progressBar">
          <div class="progressBar-Active" :style="'width:'+progressRate+'%;'"></div>
          </div>-->
          <div class="text2">{{countTime}}秒</div>
        </div>
      </div>
      <!-- 打谱棋盘1 -->
      <div class="dp-1">
        <canvas width="400" height="400" class="dp-canvas1" ref="d1"></canvas>
        <div v-if="prepareShow" class="prepare-modal">{{prepareTime}}</div>
      </div>
      <div class="right-img">
        <img src="../assets/imgs/question/rules.png" alt @click.stop="showRelusModel" />
        <img src="../assets/imgs/question/reach.png" class="two" alt @click.stop="gotoResearchMode" />
      </div>
    </div>
    <!-- 打谱棋盘2 -->
    <div class="dp-2">
      <div class="model-dp2" v-if="dpModel">
        <div class="button" @click="startDp">开始</div>
      </div>
      <canvas width="400" height="400" ref="d2" class="dp-canvas2"></canvas>
    </div>
    <!-- 打谱失败/成功 -->
    <div class="success">
      <!-- show-cancel-button
        confirm-button-text="重做本次打谱"
        cancel-button-text="退出本次打谱"
      :before-close="beforeClose"-->
      <van-popup v-model="dpSuccessShow" class="success-full-screen">
        <!-- <img src="../assets/imgs/question/right.png">
        <div class="success-text">打谱成功！</div>-->
        <div @click="closeSuccessBack" class="dp-success-imgs"></div>
      </van-popup>
      <van-dialog
        class="wrong-modal hide"
        style="overflow: initial;"
        v-model="dpFailShow"
        show-cancel-button
        confirm-button-text="重做本次打谱"
        cancel-button-text="退出本次打谱"
        :before-close="beforeClose"
      >
        <div class="wrong-wrap">
          <div class="wrong-imgs"></div>
          <div class="wrong-title">打谱失败</div>
          <div class="wrong-desc">继续努力!</div>
        </div>
        <!-- <div @click="closeModal" class="close-modal"></div> -->
      </van-dialog>
    </div>
    <Research-Mode
      v-if="researchModeShow"
      @closeResearchMode="closeResearch"
      :position="position"
      :desc="question_list[randomIndex].ask_desc"
    ></Research-Mode>
    <Rules :text="rules_text" v-if="ruleModeShow" @close="closeRelus"></Rules>
    <ScoreComponent v-if="isScoreActive" :score="score" :onClose="handleScoreClose"></ScoreComponent>
  </div>
</template>

<script>
import * as Api from '../api/index';
import Island from '../lib/island';
import headerInfo from '@/components/headerInfo.vue';
import ResearchMode from '../components/researchMode.vue';
import Rules from '@/components/rules.vue';
import ScoreComponent from '@/components/score.vue';

export default {
  name: 'Score',
  data() {
    return {
      prepareShow: false,
      prepareTime: 3,
      index: 0,
      question_list: [], // 打谱问题列表
      desc: '', // 打谱的sgf格式字符
      week_info: {},
      progressRate: 100, // 进度条
      countTime: 15, // 倒计时时间
      dpSuccessShow: false,
      dpFailShow: false,
      dpModel: true, // 开始打谱的按钮显示
      researchModeShow: false, // 研究模式开关
      position: { x: 0, y: 0, z: 0 }, // 研究模式的位置 数字代表rem x--left y--bottom z--z-index
      rules_text: '按照演示棋盘上的位置落子。每一步请在规定时间内完成。完成得到25分。',
      ruleModeShow: false,
      randomIndex: 0, // 随机题目的下标
      isScoreActive: false,
      score: 0,
    };
  },
  components: {
    ResearchMode, Rules, headerInfo, ScoreComponent,
  },
  computed: {
    timesCN() {
      const { times } = this.$route.params;
      // eslint-disable-next-line no-nested-ternary
      return times === '1' ? '一' : times === '2' ? '二' : times === '3' ? '三' : '四';
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.needClearInterval = true;
    this.$rightPlayer = new Audio(window.mp3.rightAnswerMp3);
    this.$wrongPlayer = new Audio(window.mp3.wrongAnswerMp3);

    document.addEventListener(
      'WeixinJSBridgeReady',
      (e) => {
        // play然后马上暂停，提前去加载音频
        this.$rightPlayer.play();
        this.stopRightPlayer();
        this.$wrongPlayer.play();
        this.stopWrongPlayer();
      },
      false,
    );
  },
  // 组件销毁前执行的钩子函数，跟其他生命周期钩子函数的用法相同。
  beforeDestroy() {
    // 我通常是把setInterval()定时器赋值给this实例，然后就可以像下面这么停止。
    clearInterval(this.timer);
  },
  methods: {
    init() {
      const { week, times } = this.$route.params;
      Api.getQuestionList({
        week,
        times: times - 1,
        type: 2,
      }).then((res) => {
        if (res.status === 0) {
          const { question_list, week_info } = res.content;
          this.question_list = question_list;
          this.week_info = week_info;
          this.randomIndex = Math.floor(Math.random() * question_list.length);
          this.$store.dispatch('changLoadingStatus', false);
          this.$nextTick(() => {
            this.dp();
          });
        }
      });
    },
    // 显示作业要求model
    showRelusModel() {
      this.ruleModeShow = true;
    },

    stopRightPlayer() {
      this.$rightPlayer.pause();
      this.$rightPlayer.currentTime = 0;
    },

    stopWrongPlayer() {
      this.$wrongPlayer.pause();
      this.$wrongPlayer.currentTime = 0;
    },

    handleScoreClose() {
      this.isScoreActive = false;
      wx.miniProgram.navigateBack();
    },

    // 关闭规则说明
    closeRelus() {
      this.ruleModeShow = false;
    },

    dp() {
      const that = this;
      const { Score } = Island;
      if (that.BeatTS) that.BeatTS.off();
      this.BeatTS = new Score({
        $el: [this.$refs.d1, this.$refs.d2],
        width: 400,
        sz: 9,
        content: this.question_list[this.randomIndex].ask_desc,
        ETLaZi() {
          if (!that.dpModel && !this.prepareShow) {
            clearInterval(that.timer);
            that.countDown();
          }
        },
        onError(data) {
          if (data.code === 2) {
            that.Dpfail();
          }
        },
        onSuccess(data) {
          if (data.code === 200) {
            that.DpSuccess();
          }
        },
        // 是否加载完
        completed() {
          // that.BeatTS.start();
        },
      });
    },
    /**
     * 开始打谱
     */
    startDp() {
      this.prepareShow = true;
      this.dpModel = false;

      const timer = setInterval(() => {
        if (this.prepareTime === 1) {
          this.dp();
          this.BeatTS.start();
          this.prepareShow = false;
          // this.countTime = 15
          // this.countDown()
          clearInterval(timer);
          return false;
        }
        this.prepareTime--;
      }, 1000);
    },
    /**
     * 定时器
     * @param{time:15}
     */
    countDown() {
      const that = this;
      this.countTime = 15;
      let count = 15;
      this.progressRate = 100;
      this.timer = setInterval(() => {
        count -= 1;
        this.progressRate = (count / 15) * 100;
        this.countTime -= 1;
        if (count <= 0) {
          // 重新做题
          that.Dpfail();
          clearInterval(that.timer);
        }
      }, 1000);
    },
    /**
     * 打谱失败
     */
    Dpfail() {
      clearTimeout(this.timer);
      this.$wrongPlayer.play();
      this.dpFailShow = true;
      setTimeout(() => {
        this.dpFailShow = false;
        this.isScoreActive = true;
      }, 1000);
    },
    /**
     * 打谱成功
     */
    DpSuccess() {
      this.dpSuccessShow = true;
      this.$rightPlayer.play();
      clearInterval(this.timer);
      this.submitHomeworkData();
      setTimeout(() => {
        this.score = 25;
        this.dpSuccessShow = false;
        this.isScoreActive = true;
      }, 1000);
    },

    /**
     * 关闭弹窗
     */
    beforeClose(action, done) {
      const that = this;
      // 重新做题
      this.stopWrongPlayer();
      if (action === 'confirm') {
        done();
        this.prepareTime = 3;
        this.prepareShow = false;
        this.dpModel = true;
        this.countTime = 15;
        this.progressRate = 100;
        clearInterval(that.timer);
        that.dp();
      } else {
        done();
        // 打谱失败重新回退到小程序的作业详情页面
        wx.miniProgram.navigateBack();
      }
    },

    // 点击关闭
    closeModal() {
      this.prepareTime = 3;
      this.prepareShow = false;
      this.dpFailShow = false;
      this.dpModel = true;
      this.countTime = 15;
      this.progressRate = 100;
      clearInterval(this.timer);
      this.stopWrongPlayer();
      this.dp();
    },
    // 打谱成功，就回跳页面
    closeSuccessBack() {
      wx.miniProgram.navigateBack();
    },

    // 进入研究模式
    gotoResearchMode() {
      clearInterval(this.timer);
      this.dpModel = true;
      this.dp();
      this.prepareTime = 3;
      this.prepareShow = false;
      this.countTime = 15;
      this.progressRate = 100;
      this.researchModeShow = true;
    },
    // 关闭研究模式
    closeResearch() {
      this.dpModel = true;
      clearInterval(this.timer);
      this.researchModeShow = false;
    },
    // 提交数据打谱
    submitHomeworkData() {
      const { week, times } = this.$route.params;
      const params = {
        week,
        times: times - 1,
        question_id: this.question_list[this.index].question_id,
        is_right: 0,
        is_x_type: 0,
        student_answer: '',
        type: '2', // 作业项目类型--2 3 6 x
        question_type: 2, // 题目真正的类型
      };
      Api.answer(params).then((res) => {
        if (res.status === 0) {
          console.log(res);
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss">
/* 重置样式 */
.wrong-modal.hide {
  .van-button {
    display: none !important;
  }
}
</style>

<style scoped lang="scss">
.score-page {
  background: #fff4da;
  width: 100%;
  min-height: 100%;
  height: auto;
  .top-content {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 halvePx(37) 0 halvePx(26);

    .left-part {
      width: halvePx(150);
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: halvePx(50);
        height: halvePx(135);
      }

      .countDown {
        width: halvePx(78);
        display: flex;
        flex-direction: column;
        line-height: 1;
        margin: halvePx(40) 0 0 0;

        .count-clock {
          width: 100%;
          height: halvePx(74);
          background: url('../assets/imgs/question/clock.png') no-repeat center/100%;
        }

        .text1 {
          width: 100%;
          font-size: halvePx(18);
          font-family: PingFang-SC-Regular;
          font-weight: 400;
          text-align: center;
          color: rgba(253, 185, 24, 1);
          margin: halvePx(18) 0 0 0;
        }

        .text2 {
          font-size: halvePx(30);
          font-family: PingFang-SC-Bold;
          font-weight: bold;
          color: #fdb918;
          text-align: center;
          margin: halvePx(14) 0 0 0;
        }
        // /* 进度条 */
        // .progressBar {
        //   width: halvePx(400);
        //   height: halvePx(20);
        //   background: #fae5b3;
        //   border-radius: halvePx(10);
        //   margin: auto 0;
        //   position: relative;
        //   margin-left: halvePx(-40);
        // }
        // /* 激活进度条 */
        // .progressBar-Active {
        //   height: halvePx(20);
        //   background: #fdb918;
        //   border-radius: halvePx(10);
        //   margin: auto 0;
        //   position: relative;
        // }
      }
    }
    .dp-1 {
      position: relative;
      width: 100%;
      text-align: center;
      margin-top: halvePx(20);

      .dp-canvas1 {
        width: halvePx(400);
      }
      .prepare-modal {
        position: absolute;
        left: halvePx(32);
        top: 0;
        width: halvePx(400);
        height: 100%;
        line-height: halvePx(400);
        background: rgba(0, 0, 0, 0.5);
        font-size: halvePx(100);
        font-family: PingFang-SC-Bold;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
      }
    }
    .right-img {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: 100%;
      img {
        width: halvePx(120);
        height: halvePx(120);
      }
      .two {
        margin-top: halvePx(20);
      }
    }
  }
  .dp-2 {
    position: relative;
    width: 100%;
    text-align: center;
    margin: halvePx(28) 0 0 0;
    // 模态框
    .model-dp2 {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 50%;
      width: 80%;
      transform: translate(-50%);
      background: rgba(0, 0, 0, 0.5);
      .button {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: halvePx(270);
        height: halvePx(100);
        line-height: halvePx(100);
        text-align: center;
        background: linear-gradient(180deg, rgba(144, 201, 251, 1), rgba(67, 172, 255, 1));
        border-radius: halvePx(50);
        font-size: halvePx(30);
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
    .dp-canvas2 {
      width: 80%;
    }
  }
}
.confirm {
  width: halvePx(540);
  height: halvePx(100);
  background: rgba(111, 218, 121, 1);
  border-radius: halvePx(8);
  line-height: halvePx(100);
  font-size: halvePx(30);
  font-family: PingFang-SC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  margin: halvePx(20) auto;
}
.researchMode {
  width: halvePx(540);
  height: halvePx(100);
  background: #7db9ff;
  border-radius: halvePx(8);
  line-height: halvePx(100);
  font-size: halvePx(30);
  font-family: PingFang-SC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  margin: halvePx(20) auto;
}
// 打谱成功
.success {
  img {
    width: halvePx(94);
    height: halvePx(94);
    margin: halvePx(40) auto;
    display: block;
  }
  .success-text {
    height: halvePx(30);
    font-size: halvePx(32);
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    width: 100%;
    text-align: center;
    margin: halvePx(20) auto halvePx(40);
  }
}
// 研究模式占比
.mes-right {
  position: absolute;
  right: 0;
  img {
    width: halvePx(110);
    height: halvePx(110);
  }
}
</style>
